<template>
  <el-dialog
    :title="title || $t('Basic.Tips')"
    :visible.sync="visibleDialog"
    :width="width"
    :before-close="$_handleCancel"
    :close-on-click-modal="false"
  >
    <slot></slot>

    <template #footer v-if="showSubmitButton || showCancleButton">
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="$_handleCancel"
          v-if="showCancleButton"
          >{{ cancleButtonText || $t("Basic.cancel") }}</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="$_handleConfirm"
          v-if="showSubmitButton"
          :loading="loading"
          >{{ comformButtonText || $t("Basic.Confirm") }}</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
// Code from https://juejin.im/post/5eddbaee5188254344768fdc

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },

    width: {
      type: String,
      default: "50%"
    },

    comformButtonText: {
      type: String,
      default: ""
    },

    cancleButtonText: {
      type: String,
      default: ""
    },

    title: {
      type: String,
      default: ""
    },

    // 错别字
    showCancleButton: {
      type: Boolean,
      default: true
    },

    loading: {
      type: Boolean,
      default: false
    },

    showSubmitButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.visible;
      },
      set() {
        this.$emit("update:visible");
      }
    }
  },
  methods: {
    // 对外抛出cancel事件
    $_handleCancel() {
      this.visibleDialog = false;

      this.$emit("cancel");
    },

    // 对外抛出 confirm事件
    $_handleConfirm() {
      this.$emit("confirm");
    }
  }
};
</script>

<style lang="scss"></style>
